// note that argument can be a string of an array

export function nullOrEmpty(value) {
  return !value || value.length === 0;
}
